<script setup lang="ts">
import {
  findJournalRowBySlug,
  parseJournalSectionPath,
} from '~/shared/lib/journal-routes.const';
import { useJournalEditions } from '../lib/useJournalData';
import { useJournalSeo } from '../lib/seo';
import JournalArchive from './JournalArchive.vue';

/**
 * '/journal/cre100/y2025' — one year of an edition's archive. On cre.ru it is
 * the archive block on its own, without an issue above it, and that is what a
 * year chip of an issue page leads to
 */
const route = useRoute();
const { editions } = await useJournalEditions();

const parsed = computed(() => parseJournalSectionPath(route.path));

// Years belong to editions: a tab slug in front of y2025 names no archive
const edition = computed(() => {
  if (parsed.value.kind !== 'year') return null;

  const row = findJournalRowBySlug(editions.value, parsed.value.editionSlug);

  return row?.parent !== null ? row : null;
});

const year = computed(() =>
  parsed.value.kind === 'year' ? parsed.value.year : null,
);

useJournalSeo(edition);

if (!edition.value) {
  throw createError({
    status: 404,
    message: 'Издание не найдено',
    fatal: true,
  });
}
</script>

<template>
  <div v-if="edition" :class="$style.page">
    <div :class="$style.top">
      <ButtonBack :class="$style.back" />
    </div>
    <JournalArchive :edition="edition" :year="year" />
  </div>
</template>

<style module lang="scss">
.page {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--color-white);
}

.top {
  display: flex;
  padding: var(--space-3x) var(--space-2-5x) 0;
}

.back {
  align-self: flex-start;
}

@media (max-width: 599px) {
  .top {
    padding: var(--space-2-5x) var(--space-2x) 0;
  }
}
</style>
